import instance from "@/utils/require.js"

// 固件管理--分页查询
export function apiFirmwareSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/search",
		method: "post",
		data
	})
}

// 固件管理--分页查询
export function apiFirmwareList(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/list",
		method: "post",
		data
	})
}

// 根据产品ID查询固件版本固件
export function apiFirmwareListVersion(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/list_version",
		method: "post",
		data
	})
}

// 固件管理--查询条件--产品类别
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 固件管理--查询条件--产品型号
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 固件管理--查询条件--固件类型
export function apiFirmwareTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/firmware_type",
		method: "post",
		data
	})
}

// 固件管理--查询条件--发布方
export function apiPublisherList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/publisher",
		method: "post",
		data
	})
}

// 产品列表--产品生命周期
export function apiFirmwareDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/detail",
		method: "post",
		data
	})
}

// 固件管理--查询条件--状态
export function apiStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/firmware_status",
		method: "post",
		data
	})
}

// 固件管理--查询条件--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 固件管理--添加版本
export function apiFirmwareAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/add",
		method: "post",
		data
	})
}

// 固件管理--发布版本
export function apiFirmwareRelease(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/release",
		method: "post",
		data
	})
}

// 固件管理--禁用版本
export function apiFirmwareDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/disable",
		method: "post",
		data
	})
}
export function apiFirmwareRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/rollback",
		method: "post",
		data
	})
}
export function apiFirmwareDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/delete",
		method: "post",
		data
	})
}
export function apiFirmwareUpdateConfig(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/update_config",
		method: "post",
		data
	})
}
export function apiFirmwareUpdateReleaseNotes(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/update_releaseNotes",
		method: "post",
		data
	})
}
export function apiFirmwareUpdatePosition(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/update_position",
		method: "post",
		data
	})
}
export function apiFirmwareUpdateItemCode(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/update_item_code",
		method: "post",
		data
	})
}
export function apiFirmwareRollbackConfig(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/rollback_config",
		method: "post",
		data
	})
}
export function apiFirmwareUpdateHardwareConfig(data = {}) {
	return instance({
		url: "/aim/api/v3/firmware/update_hardware_config",
		method: "post",
		data
	})
}
